import axios from "axios";
import { useAuth } from "../../provider/authContextType";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Liferay } from "../liferay/liferay";

interface QueryParams {
  IdentityDocument: string;
  IdentityDocumentTypeId: string;
}

const fetchContract = async (
  origin: string | null,
  identityDocument: string,
  identityDocumentTypeId: string
) => {
  const response = await axios.get(`${origin}/contract/mycontract`, {
    params: {
      identityDocument: identityDocument,
      identityDocumentTypeId: identityDocumentTypeId,
      userId: Liferay.ThemeDisplay.getUserId(),
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer `,
    },
  });
  return response.data;
};

export const useFetchContract = (
  identityDocument: string,
  identityDocumentTypeId: string
) => {
  const { origin } = useAuth();
  return useQuery({
    queryKey: ["contract", identityDocument, identityDocumentTypeId],
    queryFn: () => {
      return fetchContract(origin, identityDocument, identityDocumentTypeId);
    },
  });
};

export const useFetchContractMutate = () => {
  const { origin } = useAuth();
  return useMutation({
    mutationFn: (data: QueryParams) => {
      const { IdentityDocument, IdentityDocumentTypeId } = data;
      return fetchContract(origin, IdentityDocument, IdentityDocumentTypeId);
    },
  });
};
